import type { SimplifiedPlace } from '@lmn/common-search-widget';
import { type SuggestionItem, TagType } from '@/app/components/search/utils';
import { TYPE_MAP } from '../constants';
import { isDestinationType } from '../guards';

const getCSWPlaces = (suggestionItems: SuggestionItem[]): SimplifiedPlace[] =>
  suggestionItems?.map((item) => {
    const src = item.imageUrl;

    if (typeof item.code === 'string' && item.code.toLowerCase().includes(TagType.TAG)) {
      const [, code] = item.code.split('_');
      return { code, type: 'Tag', src };
    }

    const type = item.tagType ? TYPE_MAP[item.tagType] : undefined;
    if (!isDestinationType(type)) {
      return { code: item.code.toString(), type: undefined, src };
    }

    return { code: item.code.toString(), type, src };
  });

export default getCSWPlaces;
